import cloneDeep from 'lodash/cloneDeep';
import { CardItem } from './card-item.model';
import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';

const ITEMS_KEY = 'items';

export class CardCollection implements Deserializable<JsonObject, CardCollection> {
  constructor(
    public name?: string,
    public description?: string,
    public cardItems?: JsonObject<CardItem>,
    private _items?: CardItem[]
  ) {}

  deserialize(json: JsonObject) {
    if (json == null) {
      return null;
    }

    if (Object.prototype.hasOwnProperty.call(json, 'cardItems')) {
      /*
      server sends back an array of cards, but instances of CardCollection may have
      the JsonObject of CardId: Card

      [card, card, card]
      {id: card, id: card, id: card}
       */
      json[ITEMS_KEY] = [...Object.values(json['cardItems'])].map((card) => ({
        card,
        userState: card['userState'],
      }));
    }
    if (Object.prototype.hasOwnProperty.call(json, ITEMS_KEY)) {
      this.cardItems = {};
      json[ITEMS_KEY].forEach((itemJson) => {
        const _card = itemJson['card'] || {};
        this.cardItems[_card['id']] = new CardItem().deserialize(itemJson);
      });
    }

    this.name = json['name'];
    this.description = json['description'];

    return this;
  }

  clone(cardCollection?: CardCollection) {
    // TODO: when there is time for additional testing, we could use deserialize instead of cloneDeep
    return cloneDeep(cardCollection ?? this);
  }
}
